import { render, staticRenderFns } from "./CCDBreadcrumbButton.component.vue?vue&type=template&id=54b0c238&scoped=true&"
import script from "./CCDBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./CCDBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./CCDBreadcrumbButton.component.vue?vue&type=style&index=0&id=54b0c238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b0c238",
  null
  
)

export default component.exports